import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone, LogIn } from 'lucide-react';
import { useLandingContent } from '../useLandingContent';

const NAV = [
  { id: 'servizi', label: 'Servizi' },
  { id: 'chi-siamo', label: 'Chi Siamo' },
  { id: 'galleria', label: 'Progetti' },
  { id: 'area-operativa', label: 'Dove Operiamo' },
  { id: 'faq', label: 'FAQ' },
  { id: 'contatti', label: 'Contatti' },
];

export default function LandingNav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { content } = useLandingContent();
  const COMPANY = content.company;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header data-testid="landing-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? 'bg-stone-950/95 backdrop-blur shadow-lg' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between">
        <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="flex items-center gap-2.5 group" data-testid="landing-logo">
          <img src="/edilcima_logo.png" alt="EDIL CIMA S.R.L." className="w-10 h-10 rounded object-contain bg-slate-900 ring-1 ring-white/10 p-0.5" />
          <div className="hidden sm:block text-left leading-tight">
            <p className="font-black text-white text-base tracking-tight">EDIL CIMA</p>
            <p className="text-[10px] text-primary uppercase tracking-widest">S.R.L. · Calcinato (BS)</p>
          </div>
        </button>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map(n => (
            <button key={n.id} onClick={() => scrollTo(n.id)} data-testid={`nav-${n.id}`}
              className="px-3 py-2 text-sm font-semibold text-stone-200 hover:text-primary transition-colors">
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a href={`tel:${COMPANY.phoneFisso.replace(/\s/g, '')}`} data-testid="nav-tel"
            className="hidden md:flex items-center gap-2 px-3 py-2 text-sm font-bold text-white border border-white/20 rounded-md hover:bg-white/10 transition-colors">
            <Phone size={14} /> {COMPANY.phoneFisso}
          </a>
          <Link to="/app/login" data-testid="nav-login"
            className="inline-flex items-center gap-1.5 px-4 py-2.5 bg-primary text-slate-900 text-sm font-black rounded-md hover:bg-primary-hover transition-all active:scale-95 shadow-lg shadow-primary/20">
            <LogIn size={14} /> Login Gestionale
          </Link>
          <button onClick={() => setOpen(!open)} className="lg:hidden p-2 text-white" data-testid="nav-mobile-toggle">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-stone-950 border-t border-white/10 px-4 py-3" data-testid="nav-mobile">
          <div className="flex flex-col gap-1">
            {NAV.map(n => (
              <button key={n.id} onClick={() => scrollTo(n.id)}
                className="px-3 py-3 text-left text-sm font-bold text-stone-200 hover:bg-white/5 rounded-md">
                {n.label}
              </button>
            ))}
            <a href={`tel:${COMPANY.phoneFisso.replace(/\s/g, '')}`}
              className="px-3 py-3 mt-2 text-left text-sm font-bold text-primary border-t border-white/10 flex items-center gap-2">
              <Phone size={14} /> {COMPANY.phoneFisso}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
